<script>
	import { onMount } from 'svelte'
	import { cubicInOut, sineInOut } from 'svelte/easing'
	import { fade, fly } from 'svelte/transition'
	import next from 'array-next'
	import { gsap } from 'gsap'
	import { ScrollTrigger } from 'gsap/ScrollTrigger'

	export let services = []
	// console.log('services:', services)
	$: activeService = services[0]

	let myinternval

	function mouseEnter(service) {
		activeService = service
		clearInterval(myinternval)
	}

	onMount(() => {
		myinternval = setInterval(() => {
			activeService = next(services, activeService)
		}, 6000)

		gsap.registerPlugin(ScrollTrigger)

		let hstl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-services',
				start: 'top center', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		if (!window.matchMedia('(max-width: 767px)').matches) {
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-1',
				{
					width: 0,
					opacity: 0,
				},
				{
					delay: 1,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-2',
				{
					height: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-4',
				{
					width: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-3',
				{
					height: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		} else {
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-1',
				{
					width: 0,
					opacity: 0,
				},
				{
					delay: 1,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-3',
				{
					height: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-4',
				{
					width: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					width: '100%',
				}
			)
			hstl.fromTo(
				'.home-services .service-green-box .service-green-box-2',
				{
					height: 0,
					opacity: 0,
				},
				{
					delay: 0,
					duration: 0.25,
					opacity: 1,
					height: '100%',
				}
			)
		}
	})
</script>

<div class="content-wrap">
	<ul class="home-services-list">
		{#each services as service (service.name)}
			<li
				class:active={service == activeService}
				on:mouseenter={() => mouseEnter(service)}>
				<span>
					{@html service.name}
				</span>
			</li>
		{/each}
	</ul>
</div>

<div class="section-img-wrap">
	<div class="service-green-box">
		<div class="service-green-box-1" />
		<div class="service-green-box-2" />
		<div class="service-green-box-3" />
		<div class="service-green-box-4" />
	</div>
	{#each [activeService] as service (service.name)}
		{#if service.link}
			<a href={service.link}>
				<img
					src={service.img}
					alt={service.img_alt}
					class="section-img"
					in:fade={{ duration: 300 }}
					out:fade={{ delay: 295, duration: 5 }} />
			</a>
		{:else}
			<img
				src={service.img}
				alt={service.img_alt}
				class="section-img"
				in:fade={{ duration: 300 }}
				out:fade={{ delay: 295, duration: 5 }} />
		{/if}

		{#if service.excerpt || service.link}
			<div class="row" transition:fade={{ duration: 300 }}>
				{#if service.excerpt}
					<div class="service-excerpt">
						<p>
							{@html service.excerpt}
						</p>
					</div>
				{/if}

				{#if service.link}
					<a href={service.link} class="btn">
						<span>Learn More</span>
						<div class="btn-svg-wrap">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								xmlns:xlink="http://www.w3.org/1999/xlink"
								width="30px"
								height="13px">
								<path
									fill-rule="evenodd"
									fill="rgb(141, 198, 63)"
									d="M22.329,0.214 L29.858,6.064 L22.284,12.142 L22.375,7.516
									L0.606,7.697 L0.515,5.021 L22.284,4.794 L22.329,0.214 Z" />
							</svg>
						</div>
					</a>
				{/if}
			</div>
		{/if}
	{/each}
</div>
